import { Link } from 'react-router-dom';
import RevealLines from '@/components/base/RevealLines';
import { projects } from '@/mocks/site';

function Meta({ category, location }: { category: string; location: string }) {
  return (
    <p className="font-label text-[11px] uppercase tracking-[0.16em] text-secondary-600">
      {category} <span aria-hidden>/</span> {location}
    </p>
  );
}

export default function Work() {
  const [a, b, c] = projects;
  return (
    <section id="work" aria-label="Selected work" className="bg-background-50 pb-24 md:pb-32">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-6 px-4 md:px-6 pt-24 md:pt-32 pb-14 md:pb-20">
        <p className="md:col-span-3 font-label text-[11px] uppercase tracking-[0.18em] text-secondary-600">Selected work / 02</p>
        <RevealLines lines={['Moments worth', 'remembering.']} className="md:col-span-9 font-extrabold tracking-[-0.055em] leading-[0.88] text-[clamp(2.6rem,8vw,8.5rem)]" />
      </div>

      {/* A: wide image left, text right — reveals left-to-right */}
      <article>
      <Link to={`/work/${a.slug}`} className="group grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-0 px-4 md:px-6 items-end cursor-pointer">
        <div className="relative h-[70vw] md:h-[52vw] max-h-[760px] min-h-[380px] overflow-hidden rounded-[18px]" data-reveal="clip-left">
          <img src={a.src} alt={a.alt} className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-[1.2s] group-hover:scale-[1.03]" />
        </div>
        <div className="lg:pl-12 xl:pl-16" data-reveal="up">
          <Meta category={a.category} location={a.location} />
          <h3 className="mt-3 font-extrabold tracking-[-0.05em] leading-[0.9] text-[clamp(2.2rem,4.4vw,4.5rem)]">{a.title}</h3>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700 max-w-[360px]">{a.line}</p>
        </div>
      </Link>
      </article>

      {/* B: text left, portrait right — reveals right-to-left */}
      <article className="mt-20 md:mt-32">
      <Link to={`/work/${b.slug}`} className="group grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-0 px-4 md:px-6 items-end cursor-pointer">
        <div className="order-2 lg:order-1 lg:pr-12 xl:pr-16" data-reveal="up">
          <span aria-hidden className="block w-12 h-12 rounded-full bg-primary-500 mb-8" />
          <Meta category={b.category} location={b.location} />
          <h3 className="mt-3 font-extrabold tracking-[-0.05em] leading-[0.9] text-[clamp(2.2rem,4.4vw,4.5rem)]">{b.title}</h3>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700 max-w-[360px]">{b.line}</p>
        </div>
        <div className="order-1 lg:order-2 relative h-[70vw] md:h-[52vw] max-h-[760px] min-h-[380px] overflow-hidden rounded-[18px]" data-reveal="clip-right">
          <img src={b.src} alt={b.alt} className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-[1.2s] group-hover:scale-[1.03]" />
        </div>
      </Link>
      </article>

      {/* C: inset cinematic frame opening from center, title overlaid */}
      <article className="group mt-20 md:mt-32 px-4 md:px-6">
        <Link to={`/work/${c.slug}`} className="block cursor-pointer">
        <div className="relative h-[70vw] md:h-[52vw] max-h-[760px] min-h-[380px] overflow-hidden rounded-[18px] bg-foreground-950 text-background-50" data-reveal="clip-center">
          <img src={c.src} alt={c.alt} className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-[1.2s] group-hover:scale-[1.03]" />
          <div className="absolute inset-0 bg-foreground-950/40" />
          <div className="relative flex h-full flex-col items-center justify-center px-4 text-center">
            <p className="font-label text-[11px] uppercase tracking-[0.16em] text-background-100">{c.category} / {c.location}</p>
            <h3 className="mt-4 font-extrabold uppercase tracking-[-0.06em] leading-[0.85] text-[clamp(2.6rem,9vw,9rem)]">{c.title}</h3>
            <p className="mt-5 text-sm md:text-base text-background-100 max-w-[400px]">{c.line}</p>
          </div>
        </div>
        </Link>
        <p className="mt-4 font-label text-[10px] uppercase tracking-[0.16em] text-secondary-600">Illustrative portfolio concepts</p>
      </article>
    </section>
  );
}